import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { Button } from "../../../components/ui/button";
import Card from "../../../components/ui/card-snippet";
import {
  FormikInput,
  FormikSwitch,
} from "../../../components/formik-components";
import Common from "../../../helper/common";
import {
  BookingModeEnum,
  BookingStatusEnum,
  BookingTypeEnum,
  ClubPrivacyTypeEnum,
  PaymentStatusEnum,
  respEnum,
  ViewDateFormat,
} from "../../../constants/appConstant";
import Utility from "../../../helper/utilityHelper";
import AdvanceTable from "../../../components/advanceTable";

const formValidations = yup.object({
  param: yup.string().required("Phone number / Email  is required"),
  //.matches(/^\d{3}-\d{7}$/, "Phone must be in the format 301-2345678"),
});

export default function CheckUserExistance() {
  const [userData, setUserData] = useState(null);
  const [bookingData, setBookingData] = useState({ data: [] });
  const [tournamentData, setTournamentData] = useState({ data: [] });
  const [sportId, setSportId] = useState(1); //padel => 1
  // const [playerId, setPlayerId] = useState(null);
  const [id, setId] = useState(null);

  const [error, setError] = useState(null);
  const [activeTabs, setActiveTabs] = useState({
    tournament: true,
    bookings: false,
  });

  // useEffect(()=>{

  //   if(id){
  //     getBookingData(id);
  //     getTournamentData(id,sportId)
  //   }

  // },[id])


  const formikRef = React.useRef();

  useEffect(() => {
    if (userData && formikRef.current) {
      // Update only the isUmpire field
      formikRef.current.setFieldValue("isUmpire", userData.isUmpire);
    }
  }, [userData]);

  const onSubmitData = async (values) => {
    try {
      const rawParam = values.param;
      let cleanedParam;

      if (rawParam.includes("@")) {
        cleanedParam = rawParam.trim().replace(/%40/g, "@");
      } else {
        cleanedParam = Utility.cleanPhoneNumber(rawParam);
      }
      const response = await Common.ApiService.getInstance().request(
        `CheckUserExist?emailOrPhone=${cleanedParam}`,
        null,
        "GET"
      );

      if (response && response.status == respEnum.Success && response.data) {
        debugger;
        setUserData(response.data);

        setBookingData({
          data: (response.data.bookingLogs || []).map((item) => ({
            ...item,
            bookingDate: Common.moment(item.bookingDate).format(ViewDateFormat),
            paymentStatusId: item.paymentStatus,
            paymentStatus: Common.Utility.getKeyByValue(
              PaymentStatusEnum,
              item.paymentStatus
            ),
            bookingType: Common.Utility.getKeyByValue(
              BookingTypeEnum,
              item.bookingType
            ),
            bookingStatus: Common.Utility.getKeyByValue(
              BookingStatusEnum,
              item.bookingStatus
            ),
            bookingMode: Common.Utility.getKeyByValue(
              BookingModeEnum,
              item.bookingMode
            ),
          })),
          pageNumber: 1,
          totalPages: 1,
          totalDisplayed: response.data.bookingLogs?.length || 0,
        });

        setTournamentData({
          data: response.data.tournamentLogs || [],
          pageNumber: 1,
          totalPages: 1,
          totalDisplayed: response.data.tournamentLogs?.length || 0,
        });

        // Reset tabs to open tournament by default
        setActiveTabs({
          tournament: true,
          bookings: false,
        });

        setError(null);
      } else {
        setUserData(null);
        setBookingData(null);
        setTournamentData(null);
        setError("User Not Found");
      }
    } catch (err) {
      setUserData(null);
      setBookingData(null);
      setTournamentData(null);
      setError(err.message || "An error occurred");
    }
  };

  let tournamentColumns = [
    {
      title: "Player Info",
      type: "text",
      key: "playerName",
      render: (record) => (
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            {record.playerImage ? (
              <img
                src={Utility.getImagePath(record.playerImage)}
                alt="Player"
                className="w-12 h-12 object-cover rounded-full border-2 border-[#2E55B9]"
              />
            ) : (
              <div className="w-12 h-12 bg-gradient-to-br from-[#0C1B3A] to-[#2E55B9] rounded-full flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
            )}
            <div>
              <div className="font-bold text-gray-800 text-lg">
                {record.playerName || "N/A"}
              </div>
              <div className="text-sm text-[#2E55B9] font-semibold">
                Level: {(record.current_level || 0).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Tournament Stats",
      type: "text",
      key: "total_tournaments_played",
      render: (record) => (
        <div className="space-y-3">
          <div className="text-center bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] text-white rounded-lg p-3">
            <div className="text-3xl font-bold">
              {record.total_tournaments_played || 0}
            </div>
            <div className="text-sm opacity-90">Tournaments Played</div>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-green-600 font-semibold">Finals Won:</span>
              <span className="font-bold text-lg">
                {record.finals_won || 0}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Runner-up:</span>
              <span className="font-semibold">
                {record.finals_runner_up || 0}
              </span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Match Performance",
      type: "text",
      key: "total_matches",
      render: (record) => (
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-2 text-center">
            <div className="bg-green-50 rounded-lg p-2">
              <div className="text-xl font-bold text-green-600">
                {record.total_wins || 0}
              </div>
              <div className="text-xs text-gray-600">Wins</div>
            </div>
            <div className="bg-red-50 rounded-lg p-2">
              <div className="text-xl font-bold text-red-600">
                {record.total_losses || 0}
              </div>
              <div className="text-xs text-gray-600">Losses</div>
            </div>
          </div>
          <div className="space-y-1">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Matches:</span>
              <span className="font-bold">{record.total_matches || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Draws:</span>
              <span>{record.total_draws || 0}</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Win Rate & Qualification",
      type: "text",
      key: "overall_win_rate_percent",
      render: (record) => (
        <div className="space-y-3">
          <div className="text-center bg-gradient-to-r from-[#2E55B9] to-[#0C1B3A] text-white rounded-lg p-3">
            <div className="text-2xl font-bold">
              {(record.overall_win_rate_percent || 0).toFixed(1)}%
            </div>
            <div className="text-sm opacity-90">Overall Win Rate</div>
          </div>
          <div className="text-center bg-gray-100 rounded-lg p-2">
            <div className="text-lg font-bold text-[#0C1B3A]">
              {(record.group_stage_qualification_percent || 0).toFixed(1)}%
            </div>
            <div className="text-xs text-gray-600">
              Group Stage Qualification
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Win Streaks",
      type: "text",
      key: "current_win_streak",
      render: (record) => (
        <div className="space-y-3">
          <div className="text-center bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg p-3">
            <div className="text-2xl font-bold">
              {record.current_win_streak || 0}
            </div>
            <div className="text-sm opacity-90">Current Streak</div>
          </div>
          <div className="text-center bg-gray-100 rounded-lg p-2">
            <div className="text-lg font-bold text-gray-800">
              {record.longest_win_streak || 0}
            </div>
            <div className="text-xs text-gray-600">Longest Streak</div>
          </div>
        </div>
      ),
    },
  ];

  let bookingColumns = [
    {
      title: "Booking Date",
      type: "text",
      key: "bookingDate",
      render: (record) => (
        <span className="font-medium text-gray-800">
          {record.bookingDate || "N/A"}
        </span>
      ),
    },
    {
      title: "Time",
      type: "text",
      key: "bookingDetail",
      render: (record) => (
        <div className="space-y-1">
          <div className="font-medium text-gray-800">
            {record.bookingDetail || "N/A"}
          </div>
          <div className="text-sm text-gray-500">
            {record.duration || "N/A"}
          </div>
        </div>
      ),
    },
    {
      title: "Payment Status",
      type: "text",
      key: "paymentStatus",
      render: (record) => {
        const status = record.paymentStatus || "Unknown";
        const statusId = record.paymentStatusId;
        const getStatusColor = (id) => {
          switch (id) {
            case 1:
              return "bg-green-100 text-green-800";
            case 2:
              return "bg-yellow-100 text-yellow-800";
            case 3:
              return "bg-red-100 text-red-800";
            default:
              return "bg-gray-100 text-gray-800";
          }
        };
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
              statusId
            )}`}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "Booking Status",
      type: "text",
      key: "bookingStatus",
      render: (record) => {
        const status = record.bookingStatus || "Unknown";
        const statusId = record.bookingStatus;
        const getStatusColor = (status) => {
          switch (status?.toLowerCase()) {
            case "confirmed":
              return "bg-green-100 text-green-800";
            case "pending":
              return "bg-yellow-100 text-yellow-800";
            case "cancelled":
              return "bg-red-100 text-red-800";
            case "completed":
              return "bg-blue-100 text-blue-800";
            default:
              return "bg-gray-100 text-gray-800";
          }
        };
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
              status
            )}`}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "Booking Mode",
      type: "text",
      key: "bookingMode",
      render: (record) => (
        <span className="text-gray-800">{record.bookingMode || "N/A"}</span>
      ),
    },
    {
      title: "Court & Sport",
      type: "text",
      key: "courtName",
      render: (record) => (
        <div className="space-y-1">
          <div className="font-medium text-gray-800">
            {record.courtName || "N/A"}
          </div>
          <div className="text-sm text-gray-500">
            {record.sportName || "N/A"}
          </div>
        </div>
      ),
    },
    {
      title: "Amount",
      type: "text",
      key: "total",
      render: (record) => (
        <div className="space-y-1">
          <div className="font-medium text-gray-800">
            PKR {record.total || 0}
          </div>
          {record.discountAmount && record.discountAmount > 0 && (
            <div className="text-sm text-green-600">
              Discount: PKR {record.discountAmount}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Ref #",
      type: "text",
      key: "refNo",
      render: (record) => (
        <span className="font-mono text-sm text-gray-600">
          {record.refNo || "N/A"}
        </span>
      ),
    },
  ];

  //   const getBookingData = async(id)=>{
  //     try {
  //     const response =await Common.ApiService.getInstance().request(`GetBookingLogs?userId=${id}`);
  //       if (response?.data) {
  //       let obj = {
  //         data: response.data.map((item) => ({
  //           ...item,
  //           bookingDate: `${Common.moment(item.bookingDate).format(ViewDateFormat)}`,
  //           paymentStatusId: item.paymentStatus,
  //           paymentStatus: Common.Utility.getKeyByValue(
  //           PaymentStatusEnum,
  //           item.paymentStatus
  //           ),
  //           bookingType: Common.Utility.getKeyByValue(
  //           BookingTypeEnum,
  //           item.bookingType
  //           ),
  //           bookingStatus: Common.Utility.getKeyByValue(
  //           BookingStatusEnum,
  //           item.bookingStatus
  //           ),
  //           bookingMode: Common.Utility.getKeyByValue(
  //           BookingModeEnum,
  //           item.bookingMode
  //           ),
  //         })),
  //       };
  //       setBookingData(obj);
  //       setError(null);
  //     } else {
  //       setBookingData({ data: [] });
  //       setError("Not Have Booking Record");
  //     }
  //     } catch (err) {
  //       console.log(err);
  //       setError(err.message || "An error occurred");
  //     }
  //   };

  // const getTournamentData = async(id,sportId)=>{

  //     try {
  //       const params = new URLSearchParams();

  //         params.append("playerId", id);
  //         params.append("sportId", sportId)

  //     const response =await Common.ApiService.getInstance().request(`GetPlayerTournamentStats?${params.toString()}`);
  //       if (response?.data) {
  //       let obj = {
  //         data: response.data.map((item) => ({
  //           ...item,

  //         })),
  //       };
  //       setTournamentData(obj);
  //       setError(null);
  //     } else {
  //       setTournamentData({ data: [] });
  //       setError("Not Have Tournament Record");
  //     }
  //     } catch (err) {
  //       console.log(err);
  //       setError(err.message || "An error occurred");
  //     }
  //   };

  const _handleOnChange = async (id, newValue) => {
    try {
      const resp = await Common.ApiService.getInstance().request(
        `UpdateUmpire?id=${id}&isUmpire=${newValue}`,
        {},
        "POST"
      );

      if (resp && resp.status === respEnum.Success) {
        Common.SweetAlert.alert(resp.message, "success");
        setUserData((prev) => ({ ...prev, isUmpire: newValue }));
      } else {
        Common.SweetAlert.alert("Update failed", "error");
      }
    } catch (err) {
      Common.SweetAlert.alert("Something went wrong", "error");
    }
  };

  const toggleTab = (tabName) => {
    setActiveTabs((prev) => {
      // If clicking on an already active tab, close it
      if (prev[tabName]) {
        return {
          tournament: false,
          bookings: false,
        };
      }
      // If clicking on an inactive tab, close all others and open this one
      return {
        tournament: tabName === "tournament",
        bookings: tabName === "bookings",
      };
    });
  };

  return (
    <div className="space-y-6 min-h-screen bg-gray-50 p-4">
      <Card title="Check User Existence" className="shadow-xl">
        <Formik
         innerRef={formikRef}
          initialValues={{ param: "", isUmpire: false }}
          validationSchema={formValidations}
          // enableReinitialize={true}
          onSubmit={onSubmitData}
        >
          {(formikProps) => (
            <div className="space-y-6 p-6">
              {/* Search Form - Compact */}
              <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] rounded-lg p-4 text-white">
                <div className="flex items-center gap-3">
                  <div className="w-80">
                    <FormikInput
                      formikProps={formikProps}
                      name="param"
                      placeholder="Enter Phone/Email"
                      label=""
                      className="bg-white/10 border-white/20 text-white placeholder:text-white"
                    />
                  </div>
                  <Button
                    type="submit"
                    onClick={formikProps.handleSubmit}
                    disabled={formikProps.isSubmitting}
                    className="bg-white text-[#0C1B3A] hover:bg-white/90 font-semibold px-6 py-2 rounded-lg transition-colors whitespace-nowrap"
                  >
                    {formikProps.isSubmitting ? (
                      <div className="flex items-center gap-2">
                        <svg
                          className="animate-spin h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Searching...
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Search
                      </div>
                    )}
                  </Button>
                </div>
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
                  <svg
                    className="w-5 h-5 text-red-500 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-red-700 font-medium">{error}</span>
                </div>
              )}

              {userData && (
                <div className="mt-6 space-y-6">
                  {/* User Profile Card */}
                  <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] rounded-xl shadow-2xl overflow-hidden">
                    <div className="p-6 text-white">
                      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
                        {/* Profile Image */}
                        <div className="flex-shrink-0">
                          {userData.image ? (
                            <img
                              src={Utility.getImagePath(userData.image)}
                              alt="Profile"
                              className="w-24 h-24 lg:w-32 lg:h-32 object-cover rounded-full border-4 border-white shadow-lg"
                            />
                          ) : (
                            <div className="w-24 h-24 lg:w-32 lg:h-32 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                              <div className="text-center">
                                <svg
                                  className="w-12 h-12 lg:w-16 lg:h-16 text-gray-500 mx-auto mb-1"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                </svg>
                                <div className="text-xs text-gray-500 font-medium">
                                  No Image
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* User Basic Info */}
                        <div className="flex-1">
                          <h2 className="text-2xl lg:text-3xl font-bold mb-2">
                            {userData.firstName || "N/A"}{" "}
                            {userData.lastName || "N/A"}
                          </h2>
                          <div className="flex flex-wrap gap-4 text-sm lg:text-base">
                            <div className="flex items-center gap-2">
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                              </svg>
                              <span>{userData.email || "N/A"}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                              </svg>
                              <span>
                                {userData.phoneCode || ""}{" "}
                                {userData.phone || "N/A"}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Status Badges */}
                        <div className="flex flex-col gap-2">
                          <span
                            className={`px-3 py-1 rounded-full text-sm font-medium ${
                              userData.isactive
                                ? "bg-green-500 text-white"
                                : "bg-red-500 text-white"
                            }`}
                          >
                            {userData.isactive ? "Active" : "Inactive"}
                          </span>
                          <div className="flex items-center gap-2">
                            <span className="text-sm">Umpire:</span>
                            <FormikSwitch
                              formikProps={formikProps}
                              name="isUmpire"
                              onChange={(val) => {
                                formikProps.setFieldValue("isUmpire", val);
                                _handleOnChange(userData.id, val);
                              }}
                               className="data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-gray-300"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Detailed Information Grid */}
                  <div className="bg-white rounded-xl shadow-lg p-6">
                    <h3 className="text-xl font-bold mb-6 text-[#0C1B3A] border-b-2 border-[#2E55B9] pb-2">
                      Detailed Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {/* Personal Information */}
                      <div className="space-y-4">
                        <h4 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                          Personal Info
                        </h4>
                        <div className="space-y-3">
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              ID:
                            </span>
                            <span className="text-gray-800 font-semibold">
                              {userData.id || "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              DOB:
                            </span>
                            <span className="text-gray-800">
                              {userData.dob
                                ? new Date(userData.dob).toLocaleDateString()
                                : "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              Gender:
                            </span>
                            <span className="text-gray-800">
                              {userData.gender === 1
                                ? "Male"
                                : userData.gender === 2
                                ? "Female"
                                : "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              Signup Type:
                            </span>
                            <span className="text-gray-800">
                              {userData.signupTypeName || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Location Information */}
                      <div className="space-y-4">
                        <h4 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                          Location
                        </h4>
                        <div className="space-y-3">
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              Country:
                            </span>
                            <span className="text-gray-800">
                              {userData.country || "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              State:
                            </span>
                            <span className="text-gray-800">
                              {userData.state || "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              City:
                            </span>
                            <span className="text-gray-800">
                              {userData.city || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Account Information */}
                      <div className="space-y-4">
                        <h4 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                          Account Info
                        </h4>
                        <div className="space-y-3">
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              Created:
                            </span>
                            <span className="text-gray-800">
                              {userData.createdOn
                                ? new Date(
                                    userData.createdOn
                                  ).toLocaleDateString()
                                : "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              Deleted:
                            </span>
                            <span className="text-gray-800">
                              {userData.isdeleted ? "Yes" : "No"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600 font-medium">
                              External:
                            </span>
                            <span className="text-gray-800">
                              {userData.isExternal ? "Yes" : "No"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Tabbed Interface */}
              {userData && (
                <div className="space-y-6">
                  {/* Tab Navigation */}
                  <div className="flex gap-4">
                    <button
                      onClick={() => toggleTab("tournament")}
                      className={`flex items-center justify-between gap-2 px-4 py-2 rounded-lg font-semibold transition-all duration-200 min-w-[140px] ${
                        activeTabs.tournament
                          ? "bg-[#0C1B3A] text-white shadow-lg"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Tournament
                      </div>
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${
                          activeTabs.tournament ? "rotate-180" : "rotate-0"
                        }`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={() => toggleTab("bookings")}
                      className={`flex items-center justify-between gap-2 px-4 py-2 rounded-lg font-semibold transition-all duration-200 min-w-[140px] ${
                        activeTabs.bookings
                          ? "bg-[#0C1B3A] text-white shadow-lg"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Bookings
                      </div>
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${
                          activeTabs.bookings ? "rotate-180" : "rotate-0"
                        }`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* Tournament Tab Content */}
                  {activeTabs.tournament &&
                    tournamentData?.data &&
                    tournamentData.data.length > 0 && (
                      <div className="space-y-6">
                        {/* Main Tournament Stats Table */}
                        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                          <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] px-6 py-4">
                            <h3 className="text-xl font-bold text-white flex items-center gap-2">
                              <svg
                                className="w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              Tournament Statistics
                              <span className="bg-white/20 px-2 py-1 rounded-full text-sm">
                                {tournamentData.data.length} player
                                {tournamentData.data.length !== 1 ? "s" : ""}
                              </span>
                            </h3>
                          </div>
                          <div className="p-0">
                            <AdvanceTable
                              title={""}
                              columns={tournamentColumns}
                              data={tournamentData}
                              getData={setTournamentData}
                            />
                          </div>
                        </div>

                        {/* Detailed Tournament Information Cards */}
                        {tournamentData.data.map((player, playerIndex) => (
                          <div key={playerIndex} className="space-y-4">
                            {/* Recent Tournaments */}
                            {(() => {
                              try {
                                const tournaments = JSON.parse(
                                  player.recent_tournaments || "[]"
                                );
                                if (tournaments.length > 0) {
                                  return (
                                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                                      <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-5">
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center gap-3">
                                            <div className="p-2 bg-white/20 rounded-lg">
                                              <svg
                                                className="w-6 h-6 text-white"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                            <div>
                                              <h4 className="text-xl font-bold text-white">
                                                Recent Tournaments
                                              </h4>
                                              <p className="text-emerald-100 text-sm">
                                                Tournament performance history
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bg-white/20 px-3 py-1 rounded-full">
                                            <span className="text-white font-semibold text-sm">
                                              {tournaments.length} tournaments
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                          {tournaments.map(
                                            (tournament, index) => (
                                              <div
                                                key={index}
                                                className="bg-white rounded-xl p-5 border-2 border-gray-200 hover:shadow-xl hover:border-emerald-300 hover:scale-105 transition-all duration-300 group shadow-lg"
                                              >
                                                <div className="space-y-3">
                                                  <div className="flex items-start justify-between">
                                                    <h5 className="font-bold text-gray-800 text-base leading-tight group-hover:text-emerald-700 transition-colors">
                                                      {tournament.tournamentName ||
                                                        "N/A"}
                                                    </h5>
                                                    {tournament.finalsWon >
                                                      0 && (
                                                      <div className="flex items-center gap-1 text-emerald-600 text-xs font-semibold">
                                                        <span>🏆</span>
                                                        <span>
                                                          {tournament.finalsWon}
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>

                                                  <div className="flex items-center gap-2 text-sm text-gray-600">
                                                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                                                      {tournament.sportName ||
                                                        "N/A"}
                                                    </span>
                                                    <span className="text-gray-500">
                                                      •
                                                    </span>
                                                    <span>
                                                      {tournament.matches || 0}{" "}
                                                      matches
                                                    </span>
                                                  </div>

                                                  <div className="flex justify-between items-center">
                                                    <div className="flex gap-4">
                                                      <div className="text-center">
                                                        <div className="text-green-600 font-bold text-lg">
                                                          {tournament.wins || 0}
                                                        </div>
                                                        <div className="text-xs text-gray-500">
                                                          Wins
                                                        </div>
                                                      </div>
                                                      <div className="text-center">
                                                        <div className="text-red-500 font-bold text-lg">
                                                          {tournament.losses ||
                                                            0}
                                                        </div>
                                                        <div className="text-xs text-gray-500">
                                                          Losses
                                                        </div>
                                                      </div>
                                                      <div className="text-center">
                                                        <div className="text-gray-500 font-bold text-lg">
                                                          {tournament.draws ||
                                                            0}
                                                        </div>
                                                        <div className="text-xs text-gray-500">
                                                          Draws
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="pt-2 border-t border-gray-100">
                                                    <div className="text-xs text-gray-500">
                                                      {tournament.startDate
                                                        ? new Date(
                                                            tournament.startDate
                                                          ).toLocaleDateString()
                                                        : "N/A"}{" "}
                                                      -{" "}
                                                      {tournament.endDate
                                                        ? new Date(
                                                            tournament.endDate
                                                          ).toLocaleDateString()
                                                        : "N/A"}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                              return null;
                            })()}

                            {/* Top Partners */}
                            {(() => {
                              try {
                                const partners = JSON.parse(
                                  player.top_partners || "[]"
                                );
                                if (partners.length > 0) {
                                  return (
                                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                                      <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-5">
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center gap-3">
                                            <div className="p-2 bg-white/20 rounded-lg">
                                              <svg
                                                className="w-6 h-6 text-white"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                              >
                                                <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
                                              </svg>
                                            </div>
                                            <div>
                                              <h4 className="text-xl font-bold text-white">
                                                Top Partners
                                              </h4>
                                              <p className="text-blue-100 text-sm">
                                                Best performing partnerships
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bg-white/20 px-3 py-1 rounded-full">
                                            <span className="text-white font-semibold text-sm">
                                              {partners.length} partners
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                          {partners.map((partner, index) => (
                                            <div
                                              key={index}
                                              className="bg-white rounded-xl p-5 border-2 border-gray-200 hover:shadow-xl hover:border-blue-300 hover:scale-105 transition-all duration-300 group shadow-lg"
                                            >
                                              <div className="space-y-4">
                                                <div className="flex items-center gap-3">
                                                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                                                    <span className="text-white font-bold text-lg">
                                                      {partner.partnerName
                                                        ? partner.partnerName
                                                            .charAt(0)
                                                            .toUpperCase()
                                                        : "?"}
                                                    </span>
                                                  </div>
                                                  <div className="flex-1">
                                                    <h5 className="font-bold text-gray-800 text-base group-hover:text-blue-700 transition-colors">
                                                      {partner.partnerName ||
                                                        "N/A"}
                                                    </h5>
                                                    <div className="text-sm text-gray-600">
                                                      Level{" "}
                                                      {(
                                                        partner.partnerCurrentLevel ||
                                                        0
                                                      ).toFixed(2)}
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="grid grid-cols-2 gap-4">
                                                  <div className="text-center bg-green-50 rounded-lg p-3">
                                                    <div className="text-2xl font-bold text-green-600">
                                                      {(
                                                        partner.winRatePercent ||
                                                        0
                                                      ).toFixed(1)}
                                                      %
                                                    </div>
                                                    <div className="text-xs text-gray-600">
                                                      Win Rate
                                                    </div>
                                                  </div>
                                                  <div className="text-center bg-blue-50 rounded-lg p-3">
                                                    <div className="text-2xl font-bold text-blue-600">
                                                      {partner.matchesTogeher ||
                                                        0}
                                                    </div>
                                                    <div className="text-xs text-gray-600">
                                                      Matches
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="space-y-2">
                                                  <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">
                                                      Tournaments:
                                                    </span>
                                                    <span className="font-semibold text-gray-800">
                                                      {partner.tournamentsTogeher ||
                                                        0}
                                                    </span>
                                                  </div>
                                                  <div className="flex justify-between text-sm">
                                                    <span className="text-gray-600">
                                                      Wins Together:
                                                    </span>
                                                    <span className="font-semibold text-green-600">
                                                      {partner.winsTogether ||
                                                        0}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                              return null;
                            })()}

                            {/* Sports Breakdown */}
                            {(() => {
                              try {
                                const sports = JSON.parse(
                                  player.sports_breakdown || "[]"
                                );
                                if (sports.length > 0) {
                                  return (
                                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                                      <div className="bg-gradient-to-r from-purple-500 to-violet-600 px-6 py-5">
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center gap-3">
                                            <div className="p-2 bg-white/20 rounded-lg">
                                              <svg
                                                className="w-6 h-6 text-white"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                            <div>
                                              <h4 className="text-xl font-bold text-white">
                                                Sports Breakdown
                                              </h4>
                                              <p className="text-purple-100 text-sm">
                                                Performance across different
                                                sports
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bg-white/20 px-3 py-1 rounded-full">
                                            <span className="text-white font-semibold text-sm">
                                              {sports.length} sport
                                              {sports.length !== 1 ? "s" : ""}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                          {sports.map((sport, index) => (
                                            <div
                                              key={index}
                                              className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] text-white rounded-xl p-5 hover:shadow-2xl hover:scale-105 transition-all duration-300 group shadow-xl border-2 border-gray-300"
                                            >
                                              <div className="space-y-4">
                                                <div className="flex items-center justify-between">
                                                  <h5 className="font-bold text-xl group-hover:text-yellow-300 transition-colors">
                                                    {sport.sportName || "N/A"}
                                                  </h5>
                                                  <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                                                </div>

                                                <div className="grid grid-cols-2 gap-4">
                                                  <div className="text-center bg-white/10 rounded-lg p-3">
                                                    <div className="text-2xl font-bold">
                                                      {sport.tournaments || 0}
                                                    </div>
                                                    <div className="text-sm opacity-90">
                                                      Tournaments
                                                    </div>
                                                  </div>
                                                  <div className="text-center bg-white/10 rounded-lg p-3">
                                                    <div className="text-2xl font-bold">
                                                      {sport.matches || 0}
                                                    </div>
                                                    <div className="text-sm opacity-90">
                                                      Matches
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="text-center bg-white/20 rounded-lg p-4">
                                                  <div className="text-3xl font-bold text-yellow-300">
                                                    {(
                                                      sport.winRate || 0
                                                    ).toFixed(1)}
                                                    %
                                                  </div>
                                                  <div className="text-sm opacity-90">
                                                    Win Rate
                                                  </div>
                                                </div>

                                                <div className="text-center text-sm opacity-90">
                                                  {sport.wins || 0} wins out of{" "}
                                                  {sport.matches || 0} matches
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                              return null;
                            })()}

                            {/* Stage Performance */}
                            {(() => {
                              try {
                                const stages = JSON.parse(
                                  player.stage_performance || "[]"
                                );
                                if (stages.length > 0) {
                                  return (
                                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                                      <div className="bg-gradient-to-r from-indigo-600 to-purple-700 px-6 py-5">
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center gap-3">
                                            <div className="p-2 bg-white/20 rounded-lg">
                                              <svg
                                                className="w-6 h-6 text-white"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                            <div>
                                              <h4 className="text-xl font-bold text-white">
                                                Stage Performance
                                              </h4>
                                              <p className="text-indigo-100 text-sm">
                                                Performance by tournament stage
                                              </p>
                                            </div>
                                          </div>
                                          <div className="bg-white/20 px-3 py-1 rounded-full">
                                            <span className="text-white font-semibold text-sm">
                                              {stages.length} stages
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                                          {stages.map((stage, index) => (
                                            <div
                                              key={index}
                                              className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:shadow-2xl hover:border-indigo-400 hover:scale-105 transition-all duration-300 group shadow-xl"
                                            >
                                              <div className="space-y-5">
                                                <div className="text-center">
                                                  <h5 className="font-bold text-gray-800 text-xl group-hover:text-indigo-700 transition-colors">
                                                    {stage.stage || "N/A"}
                                                  </h5>
                                                </div>

                                                <div className="text-center bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-4">
                                                  <div className="text-4xl font-bold text-indigo-600">
                                                    {(
                                                      stage.winRate || 0
                                                    ).toFixed(1)}
                                                    %
                                                  </div>
                                                  <div className="text-sm text-gray-600 font-medium">
                                                    Win Rate
                                                  </div>
                                                </div>

                                                <div className="space-y-3">
                                                  <div className="flex justify-between items-center bg-gray-50 rounded-lg p-3">
                                                    <span className="text-gray-600 font-medium">
                                                      Matches:
                                                    </span>
                                                    <span className="font-bold text-gray-800 text-lg">
                                                      {stage.matches || 0}
                                                    </span>
                                                  </div>
                                                  <div className="flex justify-between items-center bg-green-50 rounded-lg p-3">
                                                    <span className="text-gray-600 font-medium">
                                                      Wins:
                                                    </span>
                                                    <span className="font-bold text-green-600 text-lg">
                                                      {stage.wins || 0}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className="space-y-2">
                                                  <div className="flex justify-between text-sm text-gray-600">
                                                    <span>Performance</span>
                                                    <span>
                                                      {(
                                                        stage.winRate || 0
                                                      ).toFixed(1)}
                                                      %
                                                    </span>
                                                  </div>
                                                  <div className="w-full bg-gray-200 rounded-full h-4">
                                                    <div
                                                      className="bg-gradient-to-r from-indigo-500 to-purple-600 h-4 rounded-full transition-all duration-700"
                                                      style={{
                                                        width: `${
                                                          stage.winRate || 0
                                                        }%`,
                                                      }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                              return null;
                            })()}
                          </div>
                        ))}
                      </div>
                    )}

                  {/* Bookings Tab Content */}
                  {activeTabs.bookings &&
                    bookingData?.data &&
                    bookingData.data.length > 0 && (
                      <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                        <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] px-6 py-4">
                          <h3 className="text-xl font-bold text-white flex items-center gap-2">
                            <svg
                              className="w-6 h-6"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                clipRule="evenodd"
                              />
                            </svg>
                            Booking Information
                            <span className="bg-white/20 px-2 py-1 rounded-full text-sm">
                              {bookingData.data.length} booking
                              {bookingData.data.length !== 1 ? "s" : ""}
                            </span>
                          </h3>
                        </div>
                        <div className="p-0">
                          <AdvanceTable
                            title={""}
                            columns={bookingColumns}
                            data={bookingData}
                            getData={setBookingData}
                          />
                        </div>
                      </div>
                    )}

                  {/* No Data Messages */}
                  {activeTabs.bookings &&
                    userData &&
                    (!bookingData?.data || bookingData.data.length === 0) && (
                      <div className="bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
                        <div className="text-gray-400 mb-4">
                          <svg
                            className="w-16 h-16 mx-auto"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-600 mb-2">
                          No Booking Records
                        </h3>
                        <p className="text-gray-500">
                          This user has no booking history.
                        </p>
                      </div>
                    )}

                  {activeTabs.tournament &&
                    userData &&
                    (!tournamentData?.data ||
                      tournamentData.data.length === 0) && (
                      <div className="bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
                        <div className="text-gray-400 mb-4">
                          <svg
                            className="w-16 h-16 mx-auto"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-600 mb-2">
                          No Tournament Records
                        </h3>
                        <p className="text-gray-500">
                          This user has no tournament statistics available.
                        </p>
                      </div>
                    )}
                </div>
              )}
            </div>
          )}
        </Formik>
      </Card>
    </div>
  );
}
